module.exports = __webpack_public_path__ + "assets/img/aboutUS-module4-2.045b2254.jpg";